<template>
<div class="wrapper" >
  <video-player class="video-player-box vjs-big-play-centered"
    ref="videoPlayer"
    :options="playerOptions"
    :playsinline="true"
    customEventName="customstatechangedeventname">
  </video-player>
</div>
</template>

<script>
export default {
  props: ['postsrc', 'autoplay'],
  data () {
    return {
      playerOptions: {
        muted: false,
        autoplay: this.autoplay,
        language: 'en',
        errorDisplay: false,
        fluid: true,
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: 'video/mp4',
          src: ''
        }],
        poster: '/img/novideo.png'
      }
    }
  },
  mounted () {
    this.playerSetSrc(this.postsrc)
    document.getElementsByClassName('video-player-box')[0].style.width = this.sliderWidth + 'px'
    if (window.innerHeight < window.innerWidth && window.innerHeight <= 414) {
      document.getElementsByClassName('video-player-box')[0].style.marginLeft = this.getPosition(document.getElementsByClassName('swiper-slide-active')[0]).left + 'px'
    } else {
      document.getElementsByClassName('video-player-box')[0].style.marginLeft = this.getPosition(document.getElementsByClassName('swiper-slide-active')[0]).left - document.getElementsByTagName('aside')[0].offsetWidth + 'px'
    }
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    },
    sliderWidth () {
      return document.getElementsByClassName('swiper-lazy')[0].offsetWidth
    }
  },
  methods: {
    playerSetSrc (url) {
      this.player.src(url)
    },
    getPosition (el) {
      const rect = el.getBoundingClientRect()
      return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY
      }
    }
  }
}
</script>

<style scoped>

  .video-player-box{
    width: 200px;
    height: auto;
  }

@media (orientation: portrait) and (min-width: 980px) {

    .video-player-box{
    width: 600px;
    height: auto;
  }
}

@media (orientation: landscape) and (max-height: 414px){
    .video-player-box{
    width: auto;
    height: auto;
    position: absolute;
    z-index:30;
  }
}

@media (orientation: portrait) and (max-width: 980px) {

    .video-player-box{
    width: auto;
    height: auto;
  }
}
</style>
